import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, Link } from "react-router-dom";
import { clearFormValues } from "../config/service";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ListItem, ListItemButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { clearProfile } from "../redux/slices/userSlice";

const Dashboard = () => {
  const [navbar, setNavbar] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 991px)");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const list = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <div
        className="bg-white scroll-bar-1 rounded-16 mt-20 mb-40 pb-20"
        style={{ width: "195px", marginLeft: "20px" }}
      >
        <List>
          {[
            { text: "Bookings", to: "booking", icon: "far fa-calendar-alt" },
            { text: "Wishlist", to: "wishlist", icon: "far fa-heart" },
            {
              text: "Reviews",
              to: "review",
              icon: "far fa-solid fa-envelope-open-text mr-15 fw-600",
            },
            { text: "Polls", to: "polls", icon: "far fa-chart-bar" },
            { text: "Profile", to: "profile", icon: "far fa-user" },
            { text: "Support", to: "support", icon: "fas fa-phone-alt" },
          ].map(({ text, icon, to }) => (
            <ListItem
              key={text}
              disablePadding
              className={`${
                navbar === text ? "bg-is-active-drawer rounded-4" : ""
              }`}
            >
              <ListItemButton
              // onClick={() => {
              //   setNavbar(text);
              //   localStorage.setItem("dashboardTab", to);
              //   navigate(`/dashboard/${to}`);
              // }}
              >
                <div key={to} className="mt-5 mb-5">
                  <div
                    className={`sidebar__button ${
                      navbar === text ? "-is-active text-primary" : ""
                    }`}
                  >
                    <Link
                      onClick={() => {
                        setNavbar(text);
                        localStorage.setItem("dashboardTab", to);
                      }}
                      to={to}
                      className="d-flex items-center text-15 lh-1 fw-400"
                    >
                      <i className={`${icon} mr-15`}></i>
                      <span className="font-inter">{text}</span>
                    </Link>
                  </div>
                </div>
              </ListItemButton>
            </ListItem>
          ))}
          <List>
            <ListItem disablePadding>
              <div className="mt-10 mb-5">
                <div
                  className="sidebar__button px-0"
                  style={{ padding: "0px !important" }}
                >
                  <button
                    onClick={async () => {
                      const shouldDelete = await Swal.fire({
                        title: "Are you sure you want to logout?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d33",
                        cancelButtonColor: "#3085d6",
                        confirmButtonText: "Yes, Logout!",
                      });

                      if (shouldDelete.isConfirmed) {
                        try {
                          dispatch(clearProfile());
                          navigate("/");
                        } catch (err) {
                          console.error("API Error:", err);
                          toast.error("Failed to Logout!");
                        }
                      }
                    }}
                    className="d-flex items-center ml-10 text-14 lh-1 fw-500 bg-primary rounded-25 text-white justify-center px-20 py-16 w-full"
                  >
                    <i className="fas fa-sign-out-alt mr-5"></i>
                    Sign Out
                  </button>
                </div>
              </div>
            </ListItem>
          </List>
        </List>
      </div>
    </Box>
  );
  useEffect(() => {
    const activeDashboardTab = localStorage.getItem("dashboardTab");

    if (activeDashboardTab) {
      switch (activeDashboardTab) {
        case "booking":
          setNavbar("Bookings");
          break;
        case "wishlist":
          setNavbar("Wishlist");
          break;
        case "review":
          setNavbar("Reviews");
          break;
        case "polls":
          setNavbar("Polls");
          break;
        case "profile":
          setNavbar("Profile");
          break;
        case "support":
          setNavbar("Support");
          break;
        default:
          setNavbar("Bookings");
          break;
      }
      navigate(`/dashboard/${activeDashboardTab}`);
    } else {
      setNavbar("Bookings");
      navigate("/dashboard/booking");
      localStorage.setItem("dashboardTab", "booking");
    }
  }, [navigate]);

  useEffect(() => {
    clearFormValues();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div data-barba="wrapper">
      {isMobile ? (
        <>
          <Button
            className="btn btn-primary text-25 d-lg-none py-10 pl-18 d-flex"
            onClick={toggleDrawer(true)}
          >
            <i className="fas fa-bars text-reading lg:mt-70 text-20"></i>
          </Button>
          {/* <div className="header-margin"></div> */}
          <section className="py-5 d-flex items-center bg-blue-1-05">
            <div className="container ml-40 lg:ml-5">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-5 items-center fw-500 font-inter text-14 text-light-1">
                    <div className="col-auto">
                      <a href="/" className="cursor-pointer">
                        Home
                      </a>
                    </div>
                    <div className="col-auto">
                      <div>{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div className="text-primary">{navbar}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <SwipeableDrawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
          >
            {list}
          </SwipeableDrawer>
          <div className="dashboard__main">
            <div className="dashboard__content">
              <Outlet />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="header-margin"></div>
          <section className="py-5 d-flex items-center bg-blue-1-05">
            <div className="container ml-40 lg:ml-5">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="row x-gap-10 y-gap-5 items-center fw-500 font-inter text-14 text-light-1">
                    <div className="col-auto">
                      <a href="/" className="cursor-pointer">
                        Home
                      </a>
                    </div>
                    <div className="col-auto">
                      <div>{">"}</div>
                    </div>
                    <div className="col-auto">
                      <div className="text-primary">{navbar}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div
            className={`dashboard ${isSidebarOpen ? "is-sidebar-open" : ""}`}
            data-x="dashboard"
            data-x-toggle="-is-sidebar-open"
          >
            <div className="dashboard__sidebar dashboard__sidebar1 bg-white scroll-bar-1 shadow-2 rounded-16 mt-20 mb-40 pt-15 py-20">
              <div className="sidebar -dashboard">
                {[
                  {
                    text: "Bookings",
                    to: "booking",
                    icon: "far fa-calendar-alt",
                  },
                  { text: "Wishlist", to: "wishlist", icon: "far fa-heart" },
                  {
                    text: "Reviews",
                    to: "review",
                    icon: "far fa-solid fa-envelope-open-text mr-15 fw-600",
                  },
                  { text: "Polls", to: "polls", icon: "far fa-chart-bar" },
                  { text: "Profile", to: "profile", icon: "far fa-user" },
                  { text: "Support", to: "support", icon: "fas fa-phone-alt" },
                ].map(({ text, to, icon }) => (
                  <div key={to} className="sidebar__item mt-5 mb-5">
                    <div
                      className={`sidebar__button ${
                        navbar === text ? "-is-active" : ""
                      }`}
                    >
                      <Link
                        onClick={() => {
                          setNavbar(text);
                          localStorage.setItem("dashboardTab", to);
                        }}
                        to={to}
                        className="d-flex items-center text-15 lh-1 fw-400"
                      >
                        <i className={`${icon} mr-15`}></i>
                        <span className="font-inter">{text}</span>
                      </Link>
                    </div>
                  </div>
                ))}
                <div className="sidebar__item mt-10 mb-5">
                  <div
                    className="sidebar__button px-0"
                    style={{ padding: "0px !important" }}
                  >
                    <button
                      onClick={async () => {
                        const shouldDelete = await Swal.fire({
                          title: "Are you sure you want to logout?",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#d33",
                          cancelButtonColor: "#3085d6",
                          confirmButtonText: "Yes, Logout!",
                        });

                        if (shouldDelete.isConfirmed) {
                          try {
                            dispatch(clearProfile());
                            navigate("/");
                          } catch (err) {
                            console.error("API Error:", err);
                            toast.error("Failed to Logout!");
                          }
                        }
                      }}
                      className="d-flex items-center text-14 lh-1 fw-500 bg-primary rounded-25 text-white justify-center px-20 py-16 w-full"
                    >
                      <i className="fas fa-sign-out-alt mr-5"></i>
                      Sign Out
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard__main">
              <div className="dashboard__content">
                <Outlet />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
